import '.a{display:flex;}.ssr-plugin'
import '.d{align-items:center;}.ssr-plugin'
import '.a8{gap:4px;}.ssr-plugin'
import React, { useState } from 'react'
import { styled, type Style } from 'inlines'
import { Button } from '../../Button/index.js'
import { Menu } from '../../Menu/index.js'
import { Badge } from '../../Badge/index.js'
import { Text } from '../../Text/index.js'
import { TextInput } from '../../TextInput/index.js'
import { Loader } from '../../Loader/index.js'
import { IconButton } from '../../IconButton/index.js'
import { getLanguageName } from '../../LanguageSelect/index.js'

export type TranslationLangSelectProps = {
  languages: string[]
  value: string
  onChange: (iso: string) => void
}

export const TranslationLangSelect = ({
  languages,
  value,
  onChange,
}: TranslationLangSelectProps) => {
  const langs: { [iso: string]: string } = {}
  for (const iso of languages) {
    langs[iso] = getLanguageName(iso)
  }
  const [selected, setSelected] = useState(value)
  const [filter, setFilter] = useState('')

  const change = (iso: string) => {
    onChange(iso)
    setSelected(iso)
  }

  return (
    <div className="a d a8">
      <Menu>
        <Menu.Trigger>
          <Button variant="ghost">{langs[selected]}</Button>
        </Menu.Trigger>
        <Menu.Items>
          <Menu.Header>
            <TextInput
              variant="ghost"
              value={filter}
              onChange={(v) => setFilter(v)}
              leadIcon="search"
              placeholder="Find language..."
              style={{ padding: '0px' }}
            />
          </Menu.Header>
          <Menu.Separator />
          <Menu.Header>Switch to...</Menu.Header>
          {Object.entries(langs)
            .filter(([, name]) =>
              name.toLowerCase().includes(filter.toLowerCase()),
            )
            .map(([iso, name]) => (
              <Menu.Item
                key={iso}
                onClick={() => {
                  change(iso)
                  setFilter('')
                }}
                leadIcon={selected === iso ? 'checkmark-normal' : null}
                style={{
                  paddingLeft: selected === iso ? 'inherit' : '40px',
                  width: '100%',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    gap: 8,
                    alignItems: 'center',
                    width: '180px',
                  }}
                >
                  <Badge color="neutral-subtle">{iso}</Badge>
                  <Text variant="display-medium">{name}</Text>
                  {/* TODO: add luigui's hook here for percentage of completion */}
                  {/* <Loader value={50} style={{ marginLeft: 'auto' }} /> */}
                </div>
              </Menu.Item>
            ))}
        </Menu.Items>
      </Menu>
      {languages.length > 1 && (
        <>
          <IconButton
            icon="chevron-up"
            onClick={() => {
              change(languages.at(languages.indexOf(selected) - 1))
            }}
          />
          <IconButton
            icon="chevron-down"
            onClick={() => {
              const current = languages.indexOf(selected)
              const next = current === languages.length - 1 ? 0 : current + 1
              change(languages.at(next))
            }}
          />
        </>
      )}
    </div>
  )
}
